import React from 'react';

import { Box, Drawer } from '@material-ui/core';

import { Entity } from '../../graphql/API';
import MobileSidebar from '../Layout/MobileSidebar';

type Props = {
  type?: Entity;
  open: boolean;
  onClose: () => void;
};

export const MobileSidebarDrawer: React.FC<Props> = ({ open, onClose }) => {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      elevation={5}
      PaperProps={{ style: { position: 'absolute', width: '100%' } }}
      BackdropProps={{ style: { position: 'absolute', width: '100%' } }}
      ModalProps={{
        container: document.getElementById('mobile-drawer-container'),
        style: { position: 'absolute' },
      }}
    >
      <Box width={'100%'}>
        <MobileSidebar />
      </Box>
    </Drawer>
  );
};
